import imageHmSelect from '@assets/images/static/img_asset_menu_hm_selection.jpg';
import imageIdeevSelect from '@assets/images/static/img_asset_menu_ideev_selection.jpg';
import imageSelect from '@assets/images/static/img_asset_menu_selection.jpg';
import { useLingui } from '@lingui/react';
import { useState, useRef } from 'react';
import ImageMapper from 'react-img-mapper';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import useSoundAudio from '~/helpers/hooks/soundAudio';
import { SPTitle } from '~/pages/components/styles/styles';

import Button from '~/pages/components/ui/button';
import ButtonSide from '~/pages/components/ui/button-side';
import { classic } from '~/themes';
import { useConnection } from '../../helpers/hooks/connection';

type TCoord = {
  coords: string;
  title: string;
  name: 'ideev' | 'hm';
  shape: string;
};
function SiteChoise() {
  const { i18n } = useLingui();
  const navigate = useNavigate();
  const [hoveredButton, setHoveredButton] = useState<'ideev' | 'hm' | null>(
    null
  );
  const { playSound } = useSoundAudio();
  const containerRef = useRef(null);
  // const ideevButtonRef = useRef<HTMLButtonElement | null>(null);
  // const hmButtonRef = useRef<HTMLButtonElement | null>(null);

  const sites: TCoord[] = [
    {
      coords:
        '338,94,517,96,535,206,523,289,358,293,257,424,531,550,529,591,476,676,54,487,45,426',

      title: 'Henri Moissan',
      name: 'hm',
      shape: 'poly',
    },
    {
      coords:
        '573,291,602,271,616,273,726,222,754,224,785,207,805,205,829,191,840,191,1031,384,1014,489,995,503,976,504,954,520,921,528,892,554,783,591,764,606,733,610,588,396',

      title: 'Ideev',
      name: 'ideev',
      shape: 'poly',
    },
  ];
  useConnection();

  function goToIdeev() {
    navigate('/ideev');
  }

  function goToMetro() {
    navigate('/hm');
  }

  function handleGo() {
    playSound('valid');
    if (hoveredButton === 'ideev') {
      goToIdeev();
    } else {
      goToMetro();
    }
  }

  function setSite(site: 'ideev' | 'hm' | null) {
    setHoveredButton(site);
    return;
  }

  function handleClickArea(name: string) {
    playSound('click');

    if (name === 'ideev') setSite('ideev');
    else setSite('hm');
  }

  return (
    <Container>
      <SDivTitle>
        <SPTitle>{i18n._('site.choose.title')}</SPTitle>
      </SDivTitle>
      <SDivImgSelect ref={containerRef}>
        <ImageMapper
          src={imageSelect}
          onClick={(e: any) => {
            handleClickArea(e.title);
          }}
          responsive={true}
          parentWidth={
            //@ts-expect-error : I know what I'm doing
            containerRef.current?.offsetWidth || 0
          }
          map={{
            name: 'click-img',
            areas: sites.map((a: TCoord) => ({
              shape: 'poly',
              coords: a.coords.split(',').map(Number),
              href: '#',
              title: a.name,
              preFillColor: 'transparent',
              strokeColor: 'transparent',
              fillColor: 'transparent',
            })),
          }}
        />
        {hoveredButton !== null && (
          <SDivImageSelected>
            <img
              src={hoveredButton === 'hm' ? imageHmSelect : imageIdeevSelect}
              alt=""
            />
          </SDivImageSelected>
        )}
      </SDivImgSelect>

      <SDivBtnWrapper>
        <SDivBtnItem>
          <SDivBtn>
            <ButtonSide
              color={hoveredButton === 'hm' ? 'primary' : 'secondary'}
              position="left"
              onClick={() => {
                playSound('click');
                setSite('hm');
              }}
            >
              {i18n._('site.hm')}
            </ButtonSide>

            <ButtonSide
              color={hoveredButton === 'ideev' ? 'primary' : 'secondary'}
              position="right"
              onClick={() => {
                playSound('click');
                setSite('ideev');
              }}
            >
              {i18n._('site.ideev')}
            </ButtonSide>
          </SDivBtn>
        </SDivBtnItem>

        <SDivBtnItem>
          <Button
            hidden={hoveredButton === null}
            color="secondary"
            onClick={handleGo}
          >
            Y aller !
          </Button>
          <SPAdviceItem hidden={hoveredButton !== null}>
            {i18n._('site.choose.advice')}
          </SPAdviceItem>
        </SDivBtnItem>
      </SDivBtnWrapper>
    </Container>
  );
}

export default SiteChoise;

//const Container = styled(Div100vh)<{ $background?: string }>`
const Container = styled.div<{ $background?: string }>`
  align-items: center;
  background-color: #bdd8dd;
  background-image: ${({ $background }) =>
    $background ? `url('${$background}')` : 'none'};
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  display: flex;
  height: 100%;
  justify-content: space-between;
  flex-direction: column;
  position: relative;
  width: 100%;
`;

const SDivTitle = styled.div`
  align-items: center;
  display: flex;
  flex: 0 0 27%;
  justify-content: center;
  width: 100%;
`;

const SDivBtnWrapper = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  flex: 0 0 25%;
  width: 100%;
`;

const SDivImgSelect = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  position: relative;
  width: 100%;
`;

const SDivImageSelected = styled.div`
  img {
    left: 0;
    top: 0;
    height: auto;
    pointer-events: none;
    position: absolute;
    width: 100%;
    z-index: 2;
  }
`;

const SDivBtnItem = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  flex: 0 0 50%;
  width: 100%;
`;

const SDivBtn = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  width: 100%;
`;

const SPAdviceItem = styled.p<{ hidden?: boolean }>`
  align-items: center;
  display: flex;
  justify-content: center;
  font-size: 1.1rem;
  color: ${classic.token?.colorTextSecondary};

  @media screen and (max-width: 415px) {
    font-size: 1rem;
  }
  @media screen and (max-height: 600px) {
    font-size: 1rem;
  }

  height: ${({ hidden }) => (hidden ? '0' : '100%')};
  transition: ${({ hidden }) =>
    hidden ? 'none' : 'height 1s linear, opacity 1s linear'};
  opacity: ${({ hidden }) => (hidden ? '0' : '1')};
  visibility: ${({ hidden }) => (hidden ? 'hidden' : 'visible')};
  width: ${({ hidden }) => (hidden ? '0' : '100%')};
`;
